import React from 'react';
import PropTypes from 'prop-types';
import styles from './region-entity-table.module.scss';
import {
  humanizeNumber,
  formatPercentageRange,
} from '../../helpers/formatters';

const HeaderCell = ({ label, value }) => {
  return (
    <div className={styles.headerCell}>
      <div style={{ display: 'inline-block' }}>
        <div className={styles.tableHeaderText}>
          {label.includes('capacity') && humanizeNumber(value, 'ml', true)}
          {label.includes('dam') && humanizeNumber(value, 'number', true)}
          {label.includes('storage') &&
            formatPercentageRange(value[0], value[1])}
        </div>
        <div className={styles.headerCellSubscript}>{label}</div>
      </div>
    </div>
  );
};

HeaderCell.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
};

export default HeaderCell;



// WEBPACK FOOTER //
// ./src/components/region-entity-table/header-cell.js